module.exports = __webpack_public_path__ + "img/04—01—02—Local IP phone credentials > Inline Edit > Dropdown.e275c283.jpg";